import type { VpIconName } from '@vtmn-play/react/headless';
import type { ReactNode } from 'react';
import { VpIcon } from '@vtmn-play/react/headless';

export interface InteractionOptionPropsType {
  icon: VpIconName;
  label: ReactNode;
  modifier?: string;
}

export const InteractionOption = ({
  icon,
  label,
}: InteractionOptionPropsType) => {
  return (
    <span className="interaction-option" data-testid="interaction-option">
      <VpIcon name={icon} size={20} />
      <span className="interaction-option__label">{label}</span>
    </span>
  );
};
